import { Injectable } from "@angular/core";
import { environment } from "../../../../../../../environments/environment";
import { Loader } from "@googlemaps/js-api-loader";

@Injectable({
  providedIn: "root",
})
export class AddressAutocompleteService {
  private loader?: Loader;
  private _placesLibrary: google.maps.PlacesLibrary | null = null;
  private autoCompleteListener?: google.maps.MapsEventListener;
  private _autoComplete?: google.maps.places.Autocomplete;
  private pacContainer: HTMLDivElement | null = null;

  get place(): google.maps.places.PlaceResult | undefined {
    return this._autoComplete?.getPlace();
  }

  get isPlacesLibrary() {
    return !!this._placesLibrary;
  }

  /**
   * will load places library from Google and if it is success will return Promise<boolean>
   * @private
   */
  private async initAddressAutoCompleteLoader(): Promise<boolean> {
    return new Promise(async resolve => {
      this.loader = new Loader({
        apiKey: environment.google_api_key,
        version: "weekly",
      });
      this._placesLibrary = await this.loader.importLibrary("places");
      resolve(!!this._placesLibrary);
    });
  }

  async initGooglePlacesLib() {
    if (this.isPlacesLibrary) {
      return Promise.resolve(true);
    }
    return await this.initAddressAutoCompleteLoader();
  }

  /**
   * will clear autocomplete listener
   */
  clearInstanceListener() {
    this.autoCompleteListener?.remove();
  }

  /**
   * Will be called after every key keystroke to load all places belongs to specific country or all countries
   * @param iso
   * @param input
   * @param cb
   */
  handlePlacesAutoComplete(iso: string, input: HTMLInputElement, types: string[] = [], cb: () => any) {
    if (!this._placesLibrary) {
      return;
    }
    this.clearInstanceListener();
    this.clearPacContainerElements();
    // @ts-ignore
    this._autoComplete = new this._placesLibrary!.Autocomplete(input, {
      fields: ["address_components", "geometry", "formatted_address", "place_id"],
      /**
       * check place type docs for more specific address for any case.
       * https://developers.google.com/maps/documentation/javascript/supported_types
       **/
      // types: ['route', 'point_of_interest','premise', 'subpremise', 'street_address']
      types,
    });
    if (iso) {
      this._autoComplete.setComponentRestrictions({ country: iso });
    }
    this.autoCompleteListener = this._autoComplete?.addListener("place_changed", cb);
    this.pacContainer = document.querySelector("div.pac-container");
  }

  /**
   * Remove the Pac widget that contains all Places from Google
   */
  clearPacContainerElements() {
    this.pacContainer?.remove();
  }

  removePlaceAutoCompleteHandler() {
    this.clearInstanceListener();
    this.clearPacContainerElements();
  }
}
